module.exports = __webpack_public_path__ + "static/media/report-2022.bac67193.pdf";